import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';

const ACTIONS = {
    GET_PLAYER_BATTER_BASIC_SUCCESS: 'GET_PLAYER_BATTER_BASIC_SUCCESS',
    GET_PLAYER_BATTER_BASIC_ERROR: 'GET_PLAYER_BATTER_BASIC_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const getPlayerBatter = (player_id) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/players/${player_id}/basic/batter`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_PLAYER_BATTER_BASIC_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_PLAYER_BATTER_BASIC_ERROR, err));
            });
    };
};

const converdataDeregis = (data) => {
    if (data.common && data.common.deregistrations) {
        const arr = data.common.deregistrations.map(value => {
            return {
                item: [
                    { text: value.transfer_date },
                    { text: value.transfer_name }
                ]
            }
        });
        return arr;
    }
}


const convertDataAchievement = (data) => {
    if (data.common && data.common.record_to_be_lasts) {
        if (data.common.record_to_be_lasts.length == 0) {
            return [{
                item : [{
                    text: '-'
                },{
                    text: '-'
                }]
            }]
        }
        const arr = data.common.record_to_be_lasts.map(value => {
            return {
                item: [
                    { text: value.achievement_record_cnt + value.record_name },
                    { text: value.remaining_achievement_cnt }
                ]
            }
        });
        return arr;
    }
}

export {
    ACTIONS, getPlayerBatter, converdataDeregis, convertDataAchievement
};